import React from "react";
import { Box } from "../../UI/Box";

export const SelectWrapper: React.FC = (props) => <Box {...props} width={280} />;
